import { collection, setDoc, doc, getDoc, increment, updateDoc, Timestamp, serverTimestamp } from 'firebase/firestore';
import React, { useEffect, useRef, useState, useMemo } from 'react'
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
//@ts-ignore
import { db } from '../utils/firebase'
import { FaChevronDown, FaDrumstickBite, FaLanguage, FaLeaf, FaUtensils, FaTimes, FaBox, FaTaxi, FaSpa, FaThumbsUp, FaTshirt, FaMapMarkedAlt, FaConciergeBell, FaCalendarAlt } from "react-icons/fa"; // Using react-icons
import Loading from '../components/Global/Loading';

import {
  FaCocktail,
  FaHeart,
  FaShoppingCart,
  FaHome,
  FaBuilding
} from 'react-icons/fa';
import { MdFoodBank, MdRestaurantMenu, MdDeliveryDining, MdOutlineDeliveryDining, MdAddBox, MdRestaurant, MdTakeoutDining, MdStorefront, MdApps } from 'react-icons/md';
import { RiTakeawayFill } from "react-icons/ri";
import { MdDelete } from "react-icons/md";

import { GiChefToque, GiFruitBowl, GiHotMeal } from 'react-icons/gi';
import FloatingMenu from "../pages/FloatingMenu";
import TopategoryNav from "../pages/TopCategoryNav";
import { v4 as uuidv4 } from 'uuid'; // for unique order ID
import { HiOutlineShoppingBag, HiChevronRight } from "react-icons/hi";
import MenuSearch from "../pages/MenuSearch"
import MenuCard from "../pages/MenuCard"
import PremiumHeader from "../components/Consumer/PremiumHeader"
import MenuItemCard from "../components/Consumer/MenuItemCard"
import trackEvent from "../utils/analytics";

export default function ConsumerMenu() {
  const DEFAULT_DISH_IMAGE =
    "https://firebasestorage.googleapis.com/v0/b/zafflostarter.firebasestorage.app/o/ImageMaster%2FDefault.png?alt=media&token=3a3362b9-8f46-4e7a-a482-d96a427729d6";
  const { businessId } = useParams();
  const [menuData, setMenuData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const hasFetchedRef = useRef(false);
  // const [openCategory, setOpenCategory] = useState(null);
  const [openCategories, setOpenCategories] = useState([]); // Start with empty array
  //console.log("open category", openCategories)
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [isServiceActive, setIsServiceActive] = useState(true);
  const [selectedLanguage, setSelectedLanguage] = useState('englishMenu');
  // New state for order summary popup
  const [showOrderSummary, setShowOrderSummary] = useState(false);
  const [selectedItemsDetails, setSelectedItemsDetails] = useState([]);
  const [orderOption, setOrderOption] = useState('');

  //console.log("selected item detals", selectedItemsDetails)

  // New state for order details
  const [tableNumber, setTableNumber] = useState('');
  const [cookingInstructions, setCookingInstructions] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [customerName, setCustomerName] = useState('');
  const [roomNumber, setRoomNumber] = useState('');
  const [deliveryAddress, setDeliveryAddress] = useState('');
  const [showOrderDetails, setShowOrderDetails] = useState(false);

  // Business type and delivery availability (should be fetched from userData)
  const [businessType, setBusinessType] = useState(); // Default to Restaurant
  const [deliveryAvailable, setDeliveryAvailable] = useState(); // Default to false
  const [takeAwayAvailable, setTakeAwayAvailable] = useState(); // Default to false
  const [itemQuantities, setItemQuantities] = useState({});
  const [orderTotal, setorderTotal] = useState("0");

  //this is for Bookings business
  const isServiceBusiness = userData?.businessSubType === "service";

  //Concent Management
  const [consentPromo, setConsentPromo] = useState(true);

  //MenuItemPupup
  const [selectedDish, setSelectedDish] = useState(null);


  //this is for preffered time 
  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const getTimeAfter20Min = () => {
    const d = new Date();
    d.setMinutes(d.getMinutes() + 20);
    return d.toTimeString().slice(0, 5);
  };

  const [preferredDate, setPreferredDate] = useState(getTodayDate());
  const [preferredTime, setPreferredTime] = useState(getTimeAfter20Min());

  //For showing top icons on menu items

  const MENU_ICON_MAP = {
    veg: { bg: "bg-green-500", icon: FaLeaf },
    jain: { bg: "bg-green-500", icon: FaLeaf },
    nonveg: { bg: "bg-red-500", icon: FaDrumstickBite },
    drink: { bg: "bg-blue-500", icon: FaCocktail },

    spa: { bg: "bg-pink-500", icon: FaSpa },
    taxi: { bg: "bg-yellow-500", icon: FaTaxi },
    experience: { bg: "bg-purple-500", icon: FaMapMarkedAlt },
    laundry: { bg: "bg-indigo-500", icon: FaTshirt },

    other: { bg: "bg-gray-500", icon: FaConciergeBell },
  };

  const getMenuIconConfig = (item) => {
    const vegType = item["Veg_NonVeg"]?.toLowerCase();
    const level1 = item["Level 1"]?.toLowerCase();

    if (vegType === "veg") return MENU_ICON_MAP.veg;
    if (vegType === "nonveg" || vegType === "non-veg") return MENU_ICON_MAP.nonveg;
    if (vegType === "drink") return MENU_ICON_MAP.drink;
    if (vegType === "spa") return MENU_ICON_MAP.spa;
    if (vegType === "taxi") return MENU_ICON_MAP.taxi;
    if (vegType === "experience") return MENU_ICON_MAP.experience;
    if (vegType === "laundry") return MENU_ICON_MAP.laundry;

    if (level1 && MENU_ICON_MAP[level1]) return MENU_ICON_MAP[level1];

    return MENU_ICON_MAP.other;
  };

  //this is for time slot management of working hours
  const generateSlots = (slots, interval = 30) => {
    const result = [];

    slots.forEach((slot) => {
      const [startH, startM] = slot.start.split(":").map(Number);
      const [endH, endM] = slot.end.split(":").map(Number);

      let current = startH * 60 + startM;
      const end = endH * 60 + endM;

      while (current <= end) {
        const h = Math.floor(current / 60)
          .toString()
          .padStart(2, "0");
        const m = (current % 60).toString().padStart(2, "0");

        result.push(`${h}:${m}`);
        current += interval;
      }
    });

    return result;
  };

  const getSlotsForSelectedDate = () => {
    if (!preferredDate) return [];

    const workingHours =
      userData?.businessRules?.workingHours;

    const dateObj = new Date(preferredDate);

    const dayName = dateObj
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();

    // ✅ If no workingHours → 24 hours open
    if (!workingHours) {
      return generateSlots([
        { start: "00:00", end: "23:30" },
      ]);
    }

    const dayConfig = workingHours[dayName];

    if (!dayConfig?.enabled) return [];

    return generateSlots(dayConfig.slots);
  };

  const getWorkingHoursInfo = () => {
    if (!preferredDate) return null;

    const workingHours =
      userData?.businessRules?.workingHours;

    const dateObj = new Date(preferredDate);

    const dayName = dateObj
      .toLocaleDateString("en-US", { weekday: "long" })
      .toLowerCase();

    // ✅ No working hours → 24 hours open
    if (!workingHours) {
      return {
        closed: false,
        message: "Open 24 hours",
      };
    }

    const dayConfig = workingHours[dayName];

    if (!dayConfig?.enabled) {
      return {
        closed: true,
        message: "We are closed on this day",
      };
    }

    const formatTime = (t) => {
      const [h, m] = t.split(":");
      const hour = parseInt(h);
      const suffix = hour >= 12 ? "PM" : "AM";
      const displayHour = hour % 12 === 0 ? 12 : hour % 12;
      return `${displayHour}:${m} ${suffix}`;
    };

    const ranges = dayConfig.slots
      .map(
        (slot) =>
          `${formatTime(slot.start)} – ${formatTime(slot.end)}`
      )
      .join(" & ");

    return {
      closed: false,
      message: `Open from ${ranges}`,
    };
  };

   useEffect(() => {
      trackEvent("menu_viewed", {
        business_slug: businessId,
        user_type: "customer"
      });
    }, [businessId]);

  useEffect(() => {
    const validSlots = getSlotsForSelectedDate();

    if (!validSlots.includes(preferredTime)) {
      setPreferredTime("");
    }
  }, [preferredDate]);

  const getDefaultTimeForSelectedDate = () => {
    const slots = getSlotsForSelectedDate();
    if (!slots.length) return "";

    const todayStr = getTodayDate();

    // If not today → select first slot
    if (preferredDate !== todayStr) {
      return slots[0];
    }

    // If today → compare with current time
    const now = new Date();
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    for (let time of slots) {
      const [h, m] = time.split(":").map(Number);
      const slotMinutes = h * 60 + m;

      if (slotMinutes >= currentMinutes) {
        return time; // Next available
      }
    }

    // If all slots are past → return last slot
    return slots[slots.length - 1];
  };

  useEffect(() => {
    if (!preferredDate) return;

    const defaultTime = getDefaultTimeForSelectedDate();

    if (!preferredTime) {
      setPreferredTime(defaultTime);
    }
  }, [preferredDate]);

  useEffect(() => {
    const slots = getSlotsForSelectedDate();

    if (!slots.includes(preferredTime)) {
      setPreferredTime(getDefaultTimeForSelectedDate());
    }
  }, [preferredDate, userData]);


  // Inside your component function
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const table = searchParams.get('table');
    const room = searchParams.get('room');

    if (table && table.trim() !== '') {
      setTableNumber(table);
    }

    if (room && room.trim() !== '') {
      setRoomNumber(room);
    }
  }, [searchParams]);

  // Toggle category expansion
  // const toggleCategory = (category) => {
  //   setOpenCategory((prev) => (prev === category ? null : category));
  // };
  const toggleCategory = (category) => {
    // Prevent default button behavior
    // e.preventDefault();
    // event.stopPropagation();

    if (openCategories.includes(category)) {
      // Remove this category to close it
      setOpenCategories(openCategories.filter(cat => cat !== category));
    } else {
      // Add this category to open it
      setOpenCategories([...openCategories, category]);
    }
  };
  // Toggle item selection


  // Check if service is active
  useEffect(() => {
    if (userData?.nextPaymentDate) {
      const nextPaymentDate = new Date(userData.nextPaymentDate);
      const cutoffDate = new Date(nextPaymentDate);
      cutoffDate.setDate(cutoffDate.getDate() + 5); // Next Payment Date + 5 Days
      //console.log('cut of date,',cutoffDate)
      setIsServiceActive(new Date() <= cutoffDate);
    }

    // Set business type and delivery availability based on userData
    if (userData) {
      setBusinessType(userData?.businessType);

      setDeliveryAvailable(userData?.homeDeliveryAvailable);
      setTakeAwayAvailable(userData?.takeAwayAvailable);
      setOrderOption(!userData?.homeDeliveryAvailable && 'dine-in')
    }
  }, [userData]);

  console.log("user data", userData)



  useEffect(() => {
    if (!businessId) {
      setError("Business Id is missing from the URL.");
      setLoading(false);
      return;
    }

   


    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;

    const fetchBusinessAndUser = async () => {
      try {
        const menuDocRef = doc(db, "menus", businessId);
        const menuSnap = await getDoc(menuDocRef);

        if (menuSnap.exists()) {
          const menuData = menuSnap.data();
          setMenuData(menuData);
          const email = menuData.email;

          if (email) {
            const userDocRef = doc(db, "userDetails", email);
            const userSnap = await getDoc(userDocRef);

            if (userSnap.exists()) {
              const userData = userSnap.data();
              setUserData(userData);
              setBusinessType(userData.businessType || 'Restaurant');

              setDeliveryAvailable(userData.deliveryAvailable || false);
              setTakeAwayAvailable(userData?.takeAwayAvailable || false);
              await updateDoc(userDocRef, {
                menuShown: increment(1),
              });
            } else {
              setError("User details not found.");
            }
          }
        } else {
          setError("Business not found.");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to fetch details.");
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessAndUser();
  }, [businessId]);

  let groupedData;
  if (menuData?.englishMenu) {
    groupedData = menuData?.[selectedLanguage].reduce((acc, item) => {
      acc[item['Level 1']] = acc[item['Level 1']] || [];
      acc[item['Level 1']].push(item);
      return acc;
    }, {});
  } else {
    groupedData = menuData?.hindiMenu.reduce((acc, item) => {
      acc[item['Level 1']] = acc[item['Level 1']] || [];
      acc[item['Level 1']].push(item);
      return acc;
    }, {});
  }

  useEffect(() => {
    let myData;
    if (menuData?.englishMenu) {
      myData = menuData?.[selectedLanguage].reduce((acc, item) => {
        acc[item['Level 1']] = acc[item['Level 1']] || [];
        acc[item['Level 1']].push(item);
        return acc;
      }, {});
    } else {
      myData = menuData?.hindiMenu?.reduce((acc, item) => {
        acc[item['Level 1']] = acc[item['Level 1']] || [];
        acc[item['Level 1']].push(item);
        return acc;
      }, {});
    }

    if (myData) {
      setOpenCategories(Object.keys(myData))
    }
  }, [menuData])

  //Floating Menu button
  const menuDataPP = useMemo(() => {
    if (!groupedData) return [];

    const newMenuData = [];

    Object.keys(groupedData).forEach((category) => {
      const categoryItems = groupedData[category] || [];

      const uniqueLevelTwoValues = [
        ...new Set(
          categoryItems
            .filter(item => item["Level 2"])
            .map(item => item["Level 2"])
        )
      ];

      uniqueLevelTwoValues.forEach((levelTwoValue) => {
        newMenuData.push({
          label: levelTwoValue,
          href: `#${levelTwoValue}`
        });
      });
    });

    return newMenuData;

  }, [groupedData]);


  // Function to remove duplicates
  const removeDuplicates = (items) => {
    const uniqueItems = [];
    const seen = new Set();
    items.forEach((item) => {
      const key = `${item['Item Name']}-${item['Price']}`;
      if (!seen.has(key)) {
        seen.add(key);
        uniqueItems.push(item);

      }
    });
    //console.log(uniqueItems);
    return uniqueItems;
  };

  // Handle language change
  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
  };


  // Get all selected items' details
  const getSelectedItemsDetails = () => {
    const allItems = [];
    Object.keys(groupedData || {}).forEach(category => {
      groupedData[category].forEach(item => {
        const uniqueKey = `${category}-${item["Item Name"]}-${item["Price"]}`;
        //console.log("jeyyyykeyyyyy keyyy", uniqueKey)
        Object.entries(itemQuantities)?.forEach(([key, value]) => {
          const myItem = key.split('-');
          //console.log('my item new qith quant', myItem)
          //console.log("hello world", key, 'val', value)
        })
        if (selectedItems.has(uniqueKey)) {
          allItems.push({
            ...item,
            category,
            uniqueKey,
          });
        }
      });
    });
    return allItems;
  };

  // Handle NEXT button click - Show order summary popup
  const handleNext = () => {
    if (selectedItems.size === 0) {
      alert("Please select at least one item before proceeding.");
      return;
    }

    const itemDetails = getSelectedItemsDetails();
    //console.log("item details", itemDetails)
    setSelectedItemsDetails(itemDetails);
    setShowOrderSummary(true);
  };
  //console.log("selected items details", selectedItemsDetails)
  // Close summary popup
  const closeSummary = () => {
    setShowOrderSummary(false);
    setOrderOption('');
    setShowOrderDetails(false);
    //setTableNumber('');
    //setRoomNumber('');
    //setDeliveryAddress('');
  };

  const resetSummary = () => {
    setShowOrderSummary(false);
    //setOrderOption('');
    setShowOrderDetails(false);
    //setTableNumber('');
    //setRoomNumber('');
    //setDeliveryAddress('');
    setSelectedItems(new Set());


  };

  // Handle order option selection
  const handleOrderOption = (option) => {
    setOrderOption(option);
    setShowOrderDetails(true);
  };

  // Generate order details string for URL
  const generateOrderString = () => {
    // Create a string with selected items

    // const itemsString = selectedItemsDetails
    //   .map(item => `${item["Item Name"]} (₹${item["Price"]})`)
    //   .join(', ');
    const itemsString = selectedItemsDetails
      .map(item => {
        const quantity = itemQuantities[item.uniqueKey] || 0; // Get the quantity
        const totalPrice = item["Price"] * quantity;          // Calculate total for this item
        return `${item["Item Name"]} x${quantity} (₹${totalPrice})`;
      })
      .join(', ');

    // Add location information based on business type and delivery option
    //console.log(orderOption);
    let locationInfo = '';
    if (orderOption === 'dine-in') {
      if (businessType === 'Restaurant') {
        locationInfo = `Table: ${tableNumber}`;
      } else if (businessType === 'Hotel') {
        locationInfo = `Room: ${roomNumber}`;
        //console.log(locationInfo);
      }
    } else if (orderOption === 'delivery') {
      locationInfo = `Delivery Address: ${deliveryAddress}`;
    } else if (orderOption === 'takeAway') {
      locationInfo = 'Take Away';
    } else if (orderOption === 'booking') {
      locationInfo = 'Booking';
    }
    const instructionsInfo = cookingInstructions ? `Cooking Instructions: ${cookingInstructions}` : 'None';
    const preferredAt = `Preferred At: ${preferredDate} ${preferredTime}`;
    const customerPhoneInfo = customerPhone ? `Phone Number: ${customerPhone}` : '';
    const customerNameInfo = customerName ? `Customer Name: ${customerName}` : '';


    //console.log('real id o========', `Items: ${itemsString} | ${locationInfo} | Total: ₹${calculateTotal()}`)
    // Combine everything into one string
    return `Items: ${itemsString} | ${locationInfo} ${instructionsInfo && `| ${instructionsInfo}`} ${preferredAt && `| ${preferredAt}`} ${customerPhoneInfo && `| ${customerPhoneInfo}`} ${customerNameInfo && `| ${customerNameInfo}`} | Total: ₹${calculateTotal()}`;
  };

  // Handle place order
  const handlePlaceOrder = () => {
    if (!customerName) {
      alert('Please enter your name');
      return;
    }

    if (!customerPhone || !/^\d{10}$/.test(customerPhone)) {
      alert('Please enter a valid 10-digit mobile number');
      return;
    }

    if (!consentPromo) {
      alert('Please agree to consent before proceeding.');
      return;
    }

    // Validate required fields
    if (orderOption === 'dine-in') {
      if (businessType === 'Restaurant' && !tableNumber) {
        alert('For Dine-In orders, please scan the QR code located on your table.');
        return;
      }
      if (businessType === 'Hotel' && !roomNumber) {
        alert('For In-Room Dine-In orders, please scan the QR code provided in your room.');
        return;
      }
    } else if (orderOption === 'delivery' && !deliveryAddress) {
      alert('Please enter a delivery address');
      return;
    }

    resetSummary();
    // Generate order string for URL
    // const orderString = encodeURIComponent(generateOrderString());

    // Create URL with order details (you can modify this to match your app's routing)

    const createWhatsAppLink = (phoneNumber, message) => {
      //console.log(message);
      const formatted = formatWhatsAppOrderMessage(message);
      const formattedMessage = encodeURIComponent(formatted);
      return `https://wa.me/${phoneNumber}?text=${formattedMessage}`;
    };

    //Helper function to format the date and time

    const formatPreferredDateTime = (dateTimeString) => {
      if (!dateTimeString) return { date: "", time: "" };

      const [datePart, timePart] = dateTimeString.split(" ");

      // ---- Format Date (DD-MM-YYYY) ----
      const [year, month, day] = datePart.split("-");
      const formattedDate = `${day}-${month}-${year}`;

      // ---- Format Time (12 hour with AM/PM) ----
      let [hours, minutes] = timePart.split(":");
      hours = parseInt(hours);

      const ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 || 12; // convert 0 → 12

      const formattedTime = `${hours}:${minutes} ${ampm}`;

      return {
        date: formattedDate,
        time: formattedTime,
      };
    };


    //format the message for whatsapp

    const formatWhatsAppOrderMessage = (rawMessage) => {
      const itemsMatch = rawMessage.match(/Items:\s*(.*?)\s*\|/);
      const tableMatch = rawMessage.match(/Table:\s*(.*?)\s*\|/);
      const deliveryAddressMatch = rawMessage.match(/Delivery Address:\s*(.*?)\s*\|/);
      const instructionsMatch = rawMessage.match(/Cooking Instructions:\s*(.*?)\s*\|/);
      const phoneMatch = rawMessage.match(/Phone Number:\s*(.*?)\s*\|/);
      const nameMatch = rawMessage.match(/Customer Name:\s*(.*?)\s*\|/);
      const totalMatch = rawMessage.match(/Total:\s*(₹[0-9]+)/);
      const preferredAtMatch = rawMessage.match(/Preferred At:\s*(.*?)\s*\|/);


      const items = itemsMatch?.[1] || "N/A";
      const tableNumber = tableMatch?.[1];
      const deliveryAddress = deliveryAddressMatch?.[1];
      const instructions = instructionsMatch?.[1] || "None";
      const phone = phoneMatch?.[1] || "N/A";
      const name = nameMatch?.[1] || "N/A";
      const total = totalMatch?.[1] || "₹0";
      const preferredAt = preferredAtMatch?.[1];

      const numericTotal = total.replace("₹", "").trim();
      setorderTotal(numericTotal);
      const lowerMsg = rawMessage.toLowerCase();
      const { date, time } = formatPreferredDateTime(preferredAt);

      let orderTypeInfo = "";

      if (deliveryAddress) {
        orderTypeInfo = `*Delivery Address:* ${deliveryAddress}`;
      } else if (lowerMsg.includes("take away")) {
        orderTypeInfo = `*Order Type:* Takeaway`;
      } else if (lowerMsg.includes("booking")) {
        orderTypeInfo = `*Order Type:* Visit Booking`;
      } else if (lowerMsg.includes("room:")) {
        const roomMatch = rawMessage.match(/Room:\s*(.*?)\s*\|/i);
        const roomNumber = roomMatch?.[1] || "N/A";
        orderTypeInfo = `*Room Number:* ${roomNumber}`;
      } else {
        orderTypeInfo = `*Table No:* ${tableNumber || "N/A"}`;
      }

      const message = `
*New Order Received*  
*Customer:* ${name}  
*Phone:* ${phone}  
${orderTypeInfo}

*Items Ordered:*  
${items}

*Instructions:* ${instructions}

${preferredAt ? `*Preferred Date:* ${date}\n*Preferred Time:* ${time}` : ""}


*Total:* ${total}

Please confirm the order.
  `.trim();

      return message;
    };

    // This is for analytics 

    function parseOrderString(orderStr) {
      const itemsMatch = orderStr.match(/Items:\s*(.+?)\s*\|/);
      const itemsStr = itemsMatch ? itemsMatch[1] : "";

      const itemsArray = itemsStr.split(",").map(item => {
        const itemMatch = item.match(/(.+?)\s*x(\d+)\s*\(₹(\d+)\)/);
        if (itemMatch) {
          return {
            name: itemMatch[1].trim(),
            qty: parseInt(itemMatch[2]),
            price: parseFloat(itemMatch[3])
          };
        }
        return null;
      }).filter(Boolean);

      const totalMatch = orderStr.match(/Total:\s*₹(\d+)/);
      const total = totalMatch ? parseFloat(totalMatch[1]) : 0;

      const phoneMatch = orderStr.match(/Phone Number:\s*(\d+)/);
      const customerPhone = phoneMatch ? phoneMatch[1] : "unknown";

      const nameMatch = orderStr.match(/Customer Name:\s*([^|]+)/);
      const customerName = nameMatch ? nameMatch[1].trim() : "unknown";

      return { itemsArray, total, customerName, customerPhone };
    }

    function getWeekNumber(date) {
      const firstDay = new Date(date.getFullYear(), 0, 1);
      const pastDays = Math.floor((date - firstDay) / 86400000);
      return Math.ceil((pastDays + firstDay.getDay() + 1) / 7);
    }

    async function updateAnalytics(orderStr, restaurantEmail) {
      const { itemsArray, total, customerName, customerPhone } = parseOrderString(orderStr);

      const today = new Date();
      const dateString = today.toISOString().slice(0, 10);
      const weekNumber = getWeekNumber(today);

      const analyticsDocRef = doc(db, "analytics", `${restaurantEmail}_${dateString}`);
      const docSnap = await getDoc(analyticsDocRef);

      if (!docSnap.exists()) {
        await setDoc(analyticsDocRef, {
          totalOrders: 0,
          totalRevenue: 0,
          weeklyOrders: {},
          weeklyRevenue: {},
          customerStats: {},
          uniqueCustomers: {},
          itemsCount: {}
        });
      }

      // Build customer update block as a nested object
      const customerUpdate = {
        [customerPhone]: {
          name: customerName,
          totalSpent: increment(total),
          ordersCount: increment(1),
        },
      };

      // Build items update block
      const itemsUpdate = {};
      itemsArray.forEach(item => {
        itemsUpdate[item.name] = increment(item.qty);
      });

      const updateData = {
        totalOrders: increment(1),
        totalRevenue: increment(total),
        weeklyOrders: {
          [weekNumber]: increment(1),
        },
        weeklyRevenue: {
          [weekNumber]: increment(total),
        },
        customerStats: customerUpdate,
        uniqueCustomers: {
          [customerPhone]: true,
        },
        itemsCount: itemsUpdate,
      };

      // Merge updates into doc
      await setDoc(analyticsDocRef, updateData, { merge: true });
    }

    //Analytics v2 Jan 2026

    function getWeekStartDate(date = new Date()) {
      const d = new Date(date);
      const day = d.getDay();
      const diff = d.getDate() - day + (day === 0 ? -6 : 1);
      return new Date(d.setDate(diff)).toISOString().slice(0, 10);
    }

    async function updateAnalyticsV2(orderStr, restaurantEmail) {
      const { itemsArray, total, customerName, customerPhone } = parseOrderString(orderStr);

      const today = new Date();
      const weekStart = getWeekStartDate(today);
      const weekNumber = getWeekNumber(today);

      const totalsRef = doc(db, "analytics_v2", restaurantEmail, "weekly", weekStart, "totals", "summary");

      // 🛡 Ensure summary doc exists
      const totalsSnap = await getDoc(totalsRef);
      if (!totalsSnap.exists()) {
        await setDoc(totalsRef, {
          weekStart,
          totalOrders: 0,
          totalRevenue: 0,
          weeklyOrders: {},
          weeklyRevenue: {},
          createdAt: serverTimestamp()
        });
      }

      // 1️⃣ Update totals
      await setDoc(totalsRef, {
        totalOrders: increment(1),
        totalRevenue: increment(total),
        weeklyOrders: { [weekNumber]: increment(1) },
        weeklyRevenue: { [weekNumber]: increment(total) },
        updatedAt: serverTimestamp()
      }, { merge: true });

      // 2️⃣ Update customer
      const customerRef = doc(db, "analytics_v2", restaurantEmail, "weekly", weekStart, "customers", customerPhone);

      await setDoc(customerRef, {
        phone: customerPhone,
        name: customerName,
        totalSpent: increment(total),
        ordersCount: increment(1),
        lastOrderAt: serverTimestamp()
      }, { merge: true });

      // 3️⃣ Update items
      for (const item of itemsArray) {
        const itemRef = doc(db, "analytics_v2", restaurantEmail, "weekly", weekStart, "items", item.name);

        await setDoc(itemRef, {
          itemName: item.name,
          qty: increment(item.qty),
          revenue: increment(item.price * item.qty)
        }, { merge: true });
      }
    }



    // Place Order button click handler
    const handlePlaceOrderFunc = async () => {
      const phoneNumber = userData?.whatsappNumber;
      const email = userData?.email;
      const rawMessage = generateOrderString();
      const orderId = uuidv4();
      const createdDateTime = new Date().toISOString();

      // Open WhatsApp with encoded message
      const whatsappLink = createWhatsAppLink(phoneNumber, rawMessage);
      window.open(whatsappLink, '_blank');

      try {
        let normalizedOrderType = "ROOM"; // default safety

        // 🔥 PRIORITY 1: If room exists → always ROOM
        if (roomNumber) {
          normalizedOrderType = "ROOM";
        }

        // 🔥 PRIORITY 2: Table-based dine-in
        else if (orderOption === "dine-in") {
          normalizedOrderType = "DINE_IN";
        }

        else if (orderOption === "takeAway") {
          normalizedOrderType = "TAKEAWAY";
        }

        else if (orderOption === "delivery") {
          normalizedOrderType = "DELIVERY";
        }

        else if (orderOption === "booking") {
          normalizedOrderType = "BOOKING";
        }

        let preferredTimestamp = null;

        if (preferredDate && preferredTime) {
          const combinedDateTime = new Date(`${preferredDate}T${preferredTime}`);
          preferredTimestamp = Timestamp.fromDate(combinedDateTime);
        }

        // Store in Firestore
        await setDoc(doc(collection(db, 'orders'), orderId), {
          orderId,
          order: rawMessage,
          createdDateTime,
          createdDateTimeFormatted: Timestamp.now(),
          email,
          delivered: false,
          consentPromo,
          orderType: normalizedOrderType,
          isBilled: false,
          tableNumber: tableNumber !== undefined && tableNumber !== ""
            ? Number(tableNumber)
            : null,
          roomNumber: roomNumber !== undefined && roomNumber !== ""
            ? Number(roomNumber)
            : null,
          address: deliveryAddress || null,
          customerName,
          customerPhone,
          cookingInstructions,
          // ✅ NEW CLEAN FIELDS
          preferredAt: preferredTimestamp,
          preferredDate,     // YYYY-MM-DD
          preferredTime,     // HH:mm (24hr) 

        });


        // await updateAnalytics(rawMessage, email);
        updateAnalyticsV2(rawMessage, email);
        trackEvent("order_placed", {business_slug: businessId,order_id: orderId, order_value: orderTotal, user_type: "customer"});

      } catch (error) {
        console.error('Failed to store order in Firestore:', error);
      }
    };
    handlePlaceOrderFunc();
    // const orderUrl = `/order-confirmation/${businessId}?details=${orderString}`;
    // console.log("order url", orderUrl)
    // Navigate to the URL (in a real app, you would use React Router's navigate)
    // window.location.href = orderUrl;
  };





  // Remove item from selection within the summary popup
  const removeItemFromSelection = (uniqueKey) => {
    setSelectedItems(prev => {
      const newSet = new Set(prev);
      newSet.delete(uniqueKey);
      return newSet;
    });

    setSelectedItemsDetails(prev =>
      prev.filter(item => item.uniqueKey !== uniqueKey)
    );

    // If all items are removed, close the popup
    if (selectedItems.size <= 1) {
      setShowOrderSummary(false);
    }
  };

  // Calculate total order amount
  // const calculateTotal = () => {
  //   return selectedItemsDetails.reduce((total, item) => 
  //     total + Number(item["Price"]), 0
  //   );
  // };
  const calculateTotal = () => {
    return selectedItemsDetails.reduce((total, item) => {
      const quantity = itemQuantities[item.uniqueKey] || 0;
      return total + (Number(item["Price"]) * quantity);
    }, 0);
  };


  if (loading) return <Loading />;
  if (error) return <p>{error}</p>;

  if (!isServiceActive || !userData?.lastPaymentAmount) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="bg-white p-8 rounded-xl shadow-lg text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">
            This service has been stopped by ZAFFLO because of Pending Payment Issue
          </h2>
          <p className="text-gray-700">Please contact support to resolve the issue.</p>
        </div>
      </div>
    );
  }

  // Add new type of Level 1 Menu category here to select proper icon
  const getCategoryIcon = (category) => {
    const categoryMap = {
      'Breakfast': <GiHotMeal className="text-yellow-600" />,
      // 'Main Course': <MdFoodBank className="text-red-600" />,
      'Appetizers': <GiFruitBowl className="text-green-600" />,
      'Desserts': <FaHeart className="text-pink-600" />,
      'Beverages': <FaCocktail className="text-white-600" />,
      'Soups': <FaUtensils className="text-orange-600" />,
      'Drinks': <FaCocktail className="text-white-600" />,
      'drink': <FaCocktail className="text-white-600" />,
      'पेय': <FaCocktail className="text-white-600" />,
      'Taxi': <FaTaxi className="text-white-600" />,
      'SPA': <FaSpa className="text-white-600" />,
      'Spa': <FaSpa className="text-white-600" />,
      'Experience': <FaHeart className="text-white-600" />,
      'Book Experience': <FaHeart className="text-white-600" />,
      'Other': <FaThumbsUp className="text-white-600" />,
      'Taxi': <FaTaxi className="text-white-600" />,
      'Local Taxi': <FaTaxi className="text-white-600" />,
      'Laundry': <FaTshirt className="text-white-600" />,
    };

    return categoryMap[category] || <MdApps className="text-white-600" />;
  };
  // console.log('scdscscsc',userData);


  // Function to toggle selection of an item
  const toggleSelectionQuantity = (uniqueKey) => {
    const newSelectedItems = new Set(selectedItems);

    if (newSelectedItems.has(uniqueKey)) {
      newSelectedItems.delete(uniqueKey);
      // Remove from quantities as well
      const newQuantities = { ...itemQuantities };
      delete newQuantities[uniqueKey];
      setItemQuantities(newQuantities);
    } else {
      newSelectedItems.add(uniqueKey);
      // Initialize quantity to 1
      setItemQuantities({ ...itemQuantities, [uniqueKey]: 1 });
    }
    //console.log('sdcsdcsdc', newSelectedItems, 'quantity', itemQuantities)
    setSelectedItems(newSelectedItems);
  };
  //console.log('sdcsdcsdc', selectedItems, 'quantity', itemQuantities)

  // Function to adjust quantity
  const adjustQuantity = (uniqueKey, change) => {
    const currentQuantity = itemQuantities[uniqueKey] || 1;
    const newQuantity = Math.max(1, currentQuantity + change);

    setItemQuantities({
      ...itemQuantities,
      [uniqueKey]: newQuantity
    });
  };

  // Function to get current quantity of an item
  const getItemQuantity = (uniqueKey) => {
    return itemQuantities[uniqueKey] || 1;
  };

  function findQuantity(item) {
    const quantity = itemQuantities[item.uniqueKey] || 0; // Find quantity or default to 0
    return (
      <div className="flex items-center mr-3">
        <span className="px-2 py-1 bg-orange-200 rounded-lg text-sm font-semibold">
          {quantity}x
        </span>
      </div>
    );
  }




  function calculatePrice(item) {
    const quantity = itemQuantities[item.uniqueKey] || 0;
    return item.Price * quantity; // Multiply price by quantity
  }
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-50 p-4 sm:p-8 font-sans">
      {/* Decorative header background */}
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-r from-amber-500 to-orange-400 rounded-b-3xl -z-10 opacity-20"></div>
      {/* <TopategoryNav menuItems={menuDataPP} className="scale-120" /> */}
      <MenuSearch
        menuItems={menuData?.englishMenu || []}
      />





      {/*  Main content */}
      <div className="relative max-w-6xl mx-auto">
        {/*<FloatingMenu />*/}

        {/* Header with decorative elements */}
        {/*   <div className="mb-12 text-center relative">
          {userData?.logo &&
            <div className="text-amber-300 opacity-75 flex justify-center">
              <img src={userData?.logo} className='w-auto h-20' alt="business logo" />
            </div>
          }

          <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4 pt-4 font-sans">
            {userData?.businessName}
          </h1>

          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-orange-500 mx-auto my-4 rounded-full"></div>

          <p className="text-amber-800 text-lg md:text-xl max-w-2xl mx-auto">
            Welcome to our Digital Menu, Please add items and place your orders.
          </p>
        </div>*/}
        <PremiumHeader userData={userData} />

        {/* Selected items counter & Next button - Fixed to bottom */}
        {selectedItems.size > 0 && (
          <div className="fixed bottom-8 inset-x-0 z-40 pointer-events-none flex justify-center animate-slideUp">
            <div className="max-w-md w-full pointer-events-auto">
              {/* The Floating Island */}
              <div className="relative group flex items-center bg-zinc-900/95 rounded-[2rem] p-2 pl-5 shadow-[0_20px_50px_rgba(0,0,0,0.4)] border border-white/10 transition-all duration-300 hover:scale-[1.02]">

                {/* Left Side: Info */}
                <div className="flex items-center gap-4 flex-1">
                  <div className="relative">
                    <HiOutlineShoppingBag className="text-amber-500" size={24} />
                    <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-white text-[10px] font-bold text-zinc-900">
                      {selectedItems.size}
                    </span>
                  </div>

                  <div className="flex flex-col">
                    <span className="text-[10px] font-bold uppercase tracking-widest text-zinc-500">
                      Your Order
                    </span>
                    <span className="text-sm font-semibold text-white">
                      {selectedItems.size} {selectedItems.size === 1 ? 'Item' : 'Items'} Selected
                    </span>
                  </div>
                </div>

                {/* Right Side: Action Button */}
                <button
                  onClick={handleNext}
                  className="ml-4 flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 px-6 py-3 rounded-[1.6rem] font-bold text-sm transition-all duration-300 active:scale-95 shadow-[0_10px_20px_rgba(245,158,11,0.2)]"
                >
                  <span>VIEW CART</span>
                  <HiChevronRight size={18} />
                </button>

                {/* Subtle Decorative Glow */}
                <div className="absolute -inset-0.5 bg-gradient-to-r from-amber-500/20 to-orange-500/0 rounded-[2rem] -z-10 opacity-50 blur-sm" />
              </div>
            </div>

            {/* Custom Animation for the Slide Up */}
            <style jsx>{`
      @keyframes slideUp {
        from { transform: translateY(100px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      .animate-slideUp {
        animation: slideUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
      }
    `}</style>
          </div>
        )}

        {/* Language Selection */}
        {menuData?.englishMenu && menuData?.hindiMenu ? (
          <div className="flex-1 mb-10">
            <div className="flex p-1 justify-end">
              {menuData?.englishMenu && (
                <button
                  onClick={() => handleLanguageChange('englishMenu')}
                  className={`py-3 px-4 rounded-xl shadow-md bg-orange flex items-center justify-center space-x-2 transition-all duration-300 ${selectedLanguage === 'englishMenu'
                    ? 'bg-amber-600 text-white shadow-md transform scale-105'
                    : 'text-gray-700 hover:bg-amber-100'
                    }`}
                >
                  <FaLanguage size={20} />
                  <span className="font-medium">English</span>
                </button>
              )}

              {menuData?.hindiMenu && (
                <button
                  onClick={() => handleLanguageChange('hindiMenu')}
                  className={`py-3 ml-5 px-4 rounded-xl shadow-md bg-orange flex items-center justify-center space-x-2 transition-all duration-300 ${selectedLanguage === 'hindiMenu'
                    ? 'bg-amber-600 text-white shadow-md transform scale-105'
                    : 'text-gray-700 hover:bg-amber-100'
                    }`}
                >
                  <FaLanguage size={20} />
                  <span className="font-medium">Indian</span>
                </button>
              )}
            </div>
          </div>
        ) : null}

        {/*Menu Section */}
        {!!menuData && (
          <div className="max-w-6xl mx-auto space-y-4 sm:space-y-6">
            <FloatingMenu menuItems={menuDataPP} className="scale-120" />

            {Object.keys(groupedData).map((category) => (
              <div key={category} className="overflow-hidden transition-all duration-300">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    toggleCategory(category);
                  }}
                  className={`w-full flex items-center justify-between text-lg sm:text-xl font-bold px-6 py-5 rounded-2xl shadow-lg transition-all duration-300 ${openCategories.includes(category)
                    ? 'bg-gradient-to-r from-gray-600 to-gray-900 text-white'
                    : 'bg-white text-amber-900 hover:shadow-xl'
                    }`}
                >
                  <div className="flex items-center space-x-3">
                    <div className="text-2xl sm:text-3xl">
                      {getCategoryIcon(category)}
                    </div>
                    <span>{category}</span>
                  </div>

                  <div className={`text-xl transition-transform duration-300 ${openCategories.includes(category) ? 'rotate-180' : ''
                    }`}>
                    <FaChevronDown />
                  </div>
                </button>

                {openCategories.includes(category) && (
                  <div className="mt-4 bg-white rounded-2xl shadow-xl overflow-hidden animate-fadeIn">
                    {(() => {
                      const categoryItems = groupedData[category] || [];
                      const uniqueLevelTwoValues = [
                        ...new Set(
                          categoryItems
                            .filter(item => item["Level 2"])
                            .map(item => item["Level 2"])
                        )
                      ];



                      return uniqueLevelTwoValues.map(levelTwoValue => {
                        let filteredItems = categoryItems.filter(item => item["Level 2"] === levelTwoValue);
                        filteredItems = filteredItems.filter(item => item.available !== false);
                        filteredItems = removeDuplicates(filteredItems);

                        if (filteredItems.length === 0) return null;

                        let colorClass = "from-gray-600 to-gray-900";

                        if (levelTwoValue.toLowerCase() === "veg") {
                          colorClass = "from-green-500 to-emerald-600";
                        } else if (levelTwoValue.toLowerCase() === "jain") {
                          colorClass = "from-yellow-500 to-amber-600";
                        } else if (levelTwoValue.toLowerCase() === "nonveg") {
                          colorClass = "from-red-500 to-rose-600";
                        } else if (levelTwoValue.toLowerCase() === "drink") {
                          colorClass = "from-blue-500 to-rose-600";
                        }

                        return (
                          <div key={levelTwoValue} id={levelTwoValue} className="p-2 border-b border-gray-100 last:border-b-0">

                            <div className="mb-6">
                              <div className={`inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r ${colorClass} text-white shadow-md`}>
                                {levelTwoValue.toLowerCase() === "drink" && <FaCocktail className="mr-2" />}
                                {levelTwoValue.toLowerCase() === "veg" && <FaLeaf className="mr-2" />}
                                {levelTwoValue.toLowerCase() === "jain" && <FaLeaf className="mr-2" />}
                                {levelTwoValue.toLowerCase() === "nonveg" && <FaDrumstickBite className="mr-2" />}
                                <h3 className="font-medium">{levelTwoValue}</h3>
                              </div>
                            </div>

                            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 gap-4">
                              {filteredItems.map((item) => {
                                const uniqueKey = `${category}-${item["Item Name"]}-${item["Price"]}`;
                                const isSelected = selectedItems.has(uniqueKey);
                                const quantity = itemQuantities[uniqueKey] || 1;

                                return (
                                  <MenuItemCard
                                    key={uniqueKey}
                                    item={item}
                                    category={category}
                                    uniqueKey={uniqueKey}
                                    isSelected={isSelected}
                                    quantity={quantity}
                                    toggleSelectionQuantity={toggleSelectionQuantity}
                                    adjustQuantity={adjustQuantity}
                                    getMenuIconConfig={getMenuIconConfig}
                                    setSelectedDish={setSelectedDish}
                                  />
                                );
                              })}

                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        {/* </div>
</div> */}

        {/* Footer decoration */}
        <div className="mt-16 text-center opacity-70 pb-20"> {/* Added padding to account for fixed bottom bar */}
          <GiChefToque size={40} className="text-[#6cbb23] mx-auto" />
          <p className="text-amber-700 mt-2">{userData?.businessName}!</p>
          <p className="m-0 text-xs">
            &copy; {new Date().getFullYear()} All rights reserved | This website is made
            <i className="fa fa-heart-o text-red-500" aria-hidden="true" /> by{' '}
            <a href="https://zafflo.com" target="_blank" rel="noreferrer" className="text-[#6cbb23] hover:underline">
              <strong>ZAFFLO</strong>
            </a>
          </p>
        </div>
      </div>

      {/* Order Summary Popup */}


      {showOrderSummary && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl shadow-[0_20px_60px_-20px_rgba(0,0,0,0.35)] max-w-xl w-full max-h-[88vh] overflow-y-auto">
            {/* Premium Header */}
            <div className="border-b border-gray-100 p-5 shrink-0">
              <div className="flex justify-between items-center">
                <div>
                  <h2 className="text-xl font-extrabold text-slate-900 tracking-tight">Order Summary</h2>
                  <p className="text-[10px] text-slate-400 uppercase tracking-widest font-semibold">Review your selection</p>
                </div>
                <button
                  onClick={closeSummary}
                  className="h-8 w-8 flex items-center justify-center rounded-full bg-slate-50 text-slate-400 hover:bg-red-50 hover:text-red-500 transition-all duration-200"
                >
                  <FaTimes size={16} />
                </button>
              </div>
            </div>

            {/* Order Items */}
            <div className="p-6">
              <div className="space-y-2 max-h-40 overflow-y-auto">
                {selectedItemsDetails.map((item) => (
                  <div key={item.uniqueKey} className="flex justify-between items-center px-3 py-2 bg-white border border-gray-100 rounded-lg hover:shadow-sm transition">

                    <div className="flex items-center">
                      {(() => {
                        const { bg, icon: Icon } = getMenuIconConfig(item);
                        return (
                          <span
                            className={`inline-flex items-center justify-center h-6 w-6 rounded-full mr-3 ${bg}`}
                          >
                            <Icon className="text-white text-xs" />
                          </span>
                        );
                      })()}

                      <div className='mr-3'>
                        <h4 className="font-medium text-gray-900">{item["Item Name"]}</h4>
                        <p className="text-sm text-gray-600">{item.category}</p>
                      </div>
                      {findQuantity(item)}
                    </div>

                    <div className="flex items-center">
                      <p className="font-bold text-amber-600 mr-4">₹{calculatePrice(item)}</p>
                      <button
                        onClick={() => removeItemFromSelection(item.uniqueKey)}
                        className="text-gray-400 hover:text-red-500 transition-colors"
                      >
                        <FaTimes />
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              {/* Order Total */}
              <div className="mt-4 py-3 px-2 bg-gray-50 rounded-lg border border-gray-100">
                <div className="flex justify-between items-center">
                  <p className="text-base font-bold text-gray-900">Total Amount:</p>
                  <p className="text-xl font-bold text-amber-600">₹{calculateTotal()}</p>
                </div>
                <p className="text-xs text-black">Taxes, if any, will be charged as per applicable laws.</p>
              </div>

              <div className="space-y-1">
                {/* Customer Info - Unified Premium Style */}
                <div className="flex gap-3 mt-1">
                  <div className="w-1/2 relative group">
                    <input
                      type="text"
                      id="customerName"
                      value={customerName}
                      onChange={(e) => setCustomerName(e.target.value)}
                      placeholder="Your Name *"
                      className="w-full text-[13px] px-4 py-2.5 rounded-xl bg-slate-50 border-transparent focus:bg-white focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-200 outline-none placeholder:text-slate-400 text-slate-700 font-medium"
                    />
                  </div>
                  <div className="w-1/2 relative group">
                    <input
                      type="tel"
                      id="customerPhone"
                      value={customerPhone}
                      onChange={(e) => setCustomerPhone(e.target.value)}
                      placeholder="Mobile Number *"
                      className="w-full text-[13px] px-4 py-2.5 rounded-xl bg-slate-50 border-transparent focus:bg-white focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-200 outline-none placeholder:text-slate-400 text-slate-700 font-medium"
                      required
                    />
                  </div>
                </div>

                {/* Instructions & Scheduling Block */}
                <div className="space-y-1 bg-white border border-slate-50 p-1 rounded-2xl">
                  {/* Instructions */}
                  <div className="relative">
                    <input
                      type="text"
                      id="cookingInstructions"
                      value={cookingInstructions}
                      onChange={(e) => setCookingInstructions(e.target.value)}
                      placeholder="Add instructions..."
                      className="w-full text-[12px] px-4 py-2.5 rounded-xl bg-slate-50/50 border-transparent focus:bg-white focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all duration-200 outline-none placeholder:text-slate-400 text-slate-700"
                    />
                  </div>

                  {/* Delivery Scheduling Area */}
                  <div className="space-y-1">
                    <div className="flex items-center gap-2 px-1">
                      <span className="h-px bg-slate-100 flex-1"></span>
                      <p className="text-[10px] font-bold uppercase tracking-[0.1em] text-slate-400 whitespace-nowrap">
                        Preferred Time
                      </p>
                      <span className="h-px bg-slate-100 flex-1"></span>
                    </div>

                    <div className="grid grid-cols-2 gap-2">
                      <input
                        type="date"
                        value={preferredDate}
                        min={getTodayDate()}
                        onChange={(e) => setPreferredDate(e.target.value)}
                        className="w-full text-[12px] px-3 py-2.5 rounded-xl bg-slate-50 border-transparent focus:bg-white focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-all outline-none text-slate-600 cursor-pointer"
                      />
                      <div className="relative group">
                        <select
                          value={preferredTime}
                          onChange={(e) => setPreferredTime(e.target.value)}
                          disabled={getSlotsForSelectedDate().length === 0}
                          className="w-full text-[12px] px-3 py-2.5 rounded-xl bg-slate-50 border-transparent focus:bg-white focus:ring-2 focus:ring-green-500/20 focus:border-green-500 transition-all outline-none text-slate-600 cursor-pointer appearance-none"
                        >
                          <option value="">
                            {getSlotsForSelectedDate().length === 0 ? "Closed" : "Select Time"}
                          </option>
                          {getSlotsForSelectedDate().map((time) => (
                            <option key={time} value={time}>{time}</option>
                          ))}
                        </select>
                        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-slate-400 group-hover:text-slate-600 transition-colors">
                          <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Working Hours Status */}
                  {preferredDate && getWorkingHoursInfo() && (
                    <div className={`px-4 py-2 rounded-xl text-[11px] font-semibold border transition-all animate-in fade-in slide-in-from-top-1 duration-300 ${getWorkingHoursInfo()?.closed
                      ? "bg-red-50/50 border-red-100 text-red-600"
                      : "bg-green-50/50 border-green-100 text-green-700"
                      }`}>
                      <span className="mr-2 inline-block h-1.5 w-1.5 rounded-full bg-current animate-pulse"></span>
                      {getWorkingHoursInfo()?.message}
                    </div>
                  )}
                </div>

                {/* Consent - Compact & Refined */}
                <div className="px-1 py-1">
                  <label className="flex items-start gap-3 cursor-pointer group select-none">
                    <div className="relative flex items-center h-5">
                      <input
                        type="checkbox"
                        id="consentPromo"
                        checked={consentPromo}
                        onChange={(e) => setConsentPromo(e.target.checked)}
                        required
                        className="peer h-4 w-4 rounded-md border-slate-200 text-amber-500 focus:ring-amber-500/20 transition-all cursor-pointer bg-slate-50"
                      />
                    </div>
                    <span className="text-[11px] font-medium text-slate-500 leading-[1.4] group-hover:text-slate-700 transition-colors">
                      I consent to receive offers via <span className="text-slate-900 font-bold">WhatsApp/SMS</span>. <span className="text-red-500 font-bold">*</span>
                    </span>
                  </label>
                </div>
              </div>



              {/* Order Options - Only show if not showing details yet */}
              {!showOrderDetails && (
                <div className="mt-2">

                  {/* Service Business Appointment Booking */}
                  {businessType === 'Restaurant' && isServiceBusiness && (
                    <div className="mt-4">
                      {/* Refined Micro-Header */}
                      <div className="flex items-center gap-2 mb-3 px-1">
                        <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-slate-400">
                          Next Step
                        </p>
                        <div className="h-px bg-slate-100 flex-1"></div>
                      </div>

                      <div className="grid grid-cols-1">
                        <button
                          onClick={() => handleOrderOption('booking')}
                          className="group relative flex items-center gap-4 p-3.5 bg-white border border-slate-100 rounded-2xl shadow-sm hover:shadow-md hover:border-amber-200 transition-all duration-300 text-left"
                        >
                          {/* Icon Container with soft glow */}
                          <div className="flex-shrink-0 flex items-center justify-center w-12 h-12 rounded-xl bg-amber-50 text-amber-600 group-hover:bg-amber-500 group-hover:text-white transition-colors duration-300">
                            <FaCalendarAlt size={20} />
                          </div>

                          {/* Text Content */}
                          <div className="flex-1">
                            <h4 className="text-sm font-bold text-slate-800 group-hover:text-amber-600 transition-colors">
                              Appointment Booking
                            </h4>
                            <p className="text-[11px] text-slate-400 font-medium">
                              Schedule your preferred time slot
                            </p>
                          </div>

                          {/* Subtle Arrow Indicator */}
                          <div className="text-slate-300 group-hover:text-amber-500 group-hover:translate-x-1 transition-all">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  )}


                  {/* For Restaurant with Delivery Available */}
                  {businessType === 'Restaurant' && !isServiceBusiness && deliveryAvailable && !takeAwayAvailable && (
                    <>
                     {/* <h3 className="text-sm font-medium text-gray-900 mb-4">What would you like to do?</h3>*/}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {(tableNumber) && (
                          <button
                            onClick={() => handleOrderOption('dine-in')}
                            className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                          >
                            <MdRestaurantMenu size={32} className="mb-2" />
                            <span>Dine In</span>
                          </button>
                        )}
                        <button
                          onClick={() => handleOrderOption('delivery')}
                          className="relative p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                        >
                          <span className="absolute top-1 right-2 text-[7px] text-amber-600">📍Address</span>
                          <MdDeliveryDining size={32} className="mb-2" />
                          <span>Home Delivery</span>
                        </button>
                      </div>
                    </>
                  )}

                  {businessType === 'Restaurant' && !isServiceBusiness && deliveryAvailable && !!takeAwayAvailable && (
                    <>
                     {/* <h3 className="text-sm font-medium text-gray-900 mb-4">What would you like to do?</h3> */}
                      <div className="grid grid-cols-3 sm:grid-cols-3 gap-4">
                        {(tableNumber) && (
                          <button
                            onClick={() => handleOrderOption('dine-in')}
                            className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                          >
                            <MdRestaurantMenu size={32} className="mb-2" />
                            <span>Dine In</span>
                          </button>
                        )}
                        <button
                          onClick={() => handleOrderOption('delivery')}
                          className="relative p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                        >
                          <span className="absolute top-1 center text-[7px] text-amber-600">📍Address</span>
                          <MdDeliveryDining size={32} className="mb-2" />
                          <span>Home Delivery</span>
                        </button>
                        <button
                          onClick={() => handleOrderOption('takeAway')}
                          className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                        >
                          <MdStorefront size={32} className="mb-2" />
                          <span>In-Store Order</span>

                        </button>
                      </div>
                    </>
                  )}

                  {/* For Hotel with Delivery Available */}
                  {/* {businessType === 'Hotel' && deliveryAvailable && (
              <>
                <h3 className="text-lg font-medium text-gray-900 mb-4">What would you like to do?</h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <button
                    onClick={() => handleOrderOption('dine-in')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdRestaurantMenu size={32} className="mb-2" />
                    <span>Dine In</span>
                  </button>
                  
                  <button
                    onClick={() => handleOrderOption('delivery')}
                    className="p-4 border-2 border-amber-500 bg-white text-amber-600 rounded-xl font-medium hover:bg-amber-50 transition-colors flex flex-col items-center"
                  >
                    <MdDeliveryDining size={32} className="mb-2" />
                    <span>Home Delivery</span>
                  </button>
                </div>
              </>
            )} */}

                  {/* For Restaurant with No Delivery - Skip options, go directly to table entry */}
                  {businessType === 'Restaurant' && !isServiceBusiness && !deliveryAvailable && !takeAwayAvailable && (
                    <div>
                      {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                      <label htmlFor="tableNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                        <FaBuilding className="mr-2" /> Table Number : {tableNumber}
                      </label>
                      <input
                        type="text"
                        id="tableNumber"
                        value={tableNumber}
                        onChange={(e) => setTableNumber(e.target.value)}
                        placeholder="Enter your table number"
                        className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                        required
                      />
                      <div className="mt-6">
                        <button
                          onClick={handlePlaceOrder}
                          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all hover:shadow-lg transition-all duration-300"
                        >
                          Place Order
                        </button>
                      </div>
                    </div>
                  )}

                  {businessType === 'Restaurant' && !isServiceBusiness && !deliveryAvailable && takeAwayAvailable && (
                    <div>
                      {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                      <label htmlFor="tableNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                        <FaBuilding className="mr-2" /> Table Number : {tableNumber}
                      </label>
                      <input
                        type="text"
                        id="tableNumber"
                        value={tableNumber}
                        onChange={(e) => setTableNumber(e.target.value)}
                        placeholder="Enter your table number"
                        className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                        required
                      />
                      <div className="mt-6">
                        <button
                          onClick={handlePlaceOrder}
                          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all hover:shadow-lg transition-all duration-300"
                        >
                          Place Order
                        </button>
                      </div>
                      <h2 className='text-center'>Or</h2>
                      <div className="mt-1">
                        <button
                          onClick={handlePlaceOrder}
                          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all hover:shadow-lg transition-all duration-300"
                        >
                          In-Store Order
                        </button>
                      </div>
                    </div>
                  )}

                  {/* For Hotel with No Delivery - Skip options, go directly to room entry */}
                  {businessType === 'Hotel' && (
                    <div>
                      {/*<h3 className="text-lg font-medium text-gray-900 mb-4">Enter Your Details</h3>*/}
                      <label htmlFor="roomNumber" className="block text-gray-700 font-medium mb-2 flex items-center">
                        <FaBuilding className="mr-2" /> Room Number : {roomNumber}
                      </label>
                      <input
                        type="text"
                        id="roomNumber"
                        value={roomNumber}
                        onChange={(e) => setRoomNumber(e.target.value)}
                        placeholder="Enter your room number"
                        className="hidden w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500"
                        required
                      />
                      <div className="mt-6">
                        <button
                          onClick={handlePlaceOrder}
                          className="w-full bg-gradient-to-r from-amber-500 to-orange-500 text-white px-5 py-2.5 rounded-lg font-semibold shadow-md hover:shadow-lg transition-all hover:shadow-lg transition-all duration-300"
                        >
                          Place Order
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}





              {/* Conditional Order Details Form - Only show after option selection */}
              {showOrderDetails && (
                <div className="mt-2 space-y-2">
                  {/* Section Header - Subtle Divider */}
                  <div className="flex items-center gap-2 px-1">
                    <span className="h-px bg-slate-100 flex-1"></span>
                    <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-slate-400">
                      Final Confirmation
                    </p>
                    <span className="h-px bg-slate-100 flex-1"></span>
                  </div>

                  {/* Dynamic Order Detail Cards */}
                  <div className="space-y-1">
                    {/* Dine In - Styled as an "Info Chip" */}
                    {orderOption === 'dine-in' && (
                      <div className="animate-in fade-in zoom-in-95 duration-300">
                        {businessType === 'Restaurant' && (
                          <div className="flex items-center justify-between p-3.5 rounded-2xl bg-amber-50/50 border border-amber-100">
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-lg bg-amber-500 flex items-center justify-center text-white shadow-sm shadow-amber-200">
                                <FaBuilding size={14} />
                              </div>
                              <span className="text-xs font-bold text-amber-900 uppercase tracking-wide">Table Number</span>
                            </div>
                            <span className="text-lg font-black text-amber-600 tracking-tight">{tableNumber}</span>
                            <input type="text" id="tableNumber" value={tableNumber} onChange={(e) => setTableNumber(e.target.value)} className="hidden" readOnly />
                          </div>
                        )}

                        {userData?.businessType === 'Hotel' && (
                          <div className="flex items-center justify-between p-3.5 rounded-2xl bg-blue-50/50 border border-blue-100">
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-lg bg-blue-500 flex items-center justify-center text-white shadow-sm shadow-blue-200">
                                <FaBuilding size={14} />
                              </div>
                              <span className="text-xs font-bold text-blue-900 uppercase tracking-wide">Room Number</span>
                            </div>
                            <span className="text-lg font-black text-blue-600 tracking-tight">{roomNumber}</span>
                            <input type="text" id="roomNumber" value={roomNumber} onChange={(e) => setRoomNumber(e.target.value)} className="hidden" readOnly />
                          </div>
                        )}
                      </div>
                    )}

                    {/* Delivery Address - Premium Input Style */}
                    {orderOption === 'delivery' && (
                      <div className="space-y-2 animate-in slide-in-from-bottom-2 duration-300">
                        <label htmlFor="deliveryAddress" className="flex items-center gap-2 px-1 text-[11px] font-bold text-slate-500 uppercase tracking-wide">
                          <FaHome className="text-amber-500" /> Delivery Address
                        </label>
                        <input
                          type="text"
                          id="deliveryAddress"
                          value={deliveryAddress}
                          onChange={(e) => setDeliveryAddress(e.target.value)}
                          placeholder="Enter your delivery address"
                          className="w-full px-4 py-3 rounded-xl bg-slate-50 border-slate-100 focus:bg-white focus:ring-4 focus:ring-amber-500/10 focus:border-amber-500 transition-all outline-none text-sm text-slate-700 placeholder:text-slate-400 shadow-sm"
                          required
                        />
                      </div>
                    )}

                    {/* TakeAway - Minimal Banner */}
                    {orderOption === 'takeAway' && (
                      <div className="flex items-center gap-3 p-3.5 rounded-2xl bg-slate-50 border border-slate-100 text-slate-600 animate-in fade-in duration-300">
                        <div className="w-8 h-8 rounded-lg bg-white border border-slate-200 flex items-center justify-center shadow-sm">
                          <MdStorefront size={18} className="text-slate-500" />
                        </div>
                        <p className="text-sm font-bold tracking-tight">In-Store Order / Takeaway</p>
                      </div>
                    )}

                    {/* Booking - Status Banner */}
                    {orderOption === 'booking' && (
                      <div className="p-4 rounded-2xl bg-green-50/50 border border-green-100 space-y-1 animate-in fade-in duration-300">
                        <div className="flex items-center gap-2 text-green-700">
                          <FaCalendarAlt size={14} />
                          <p className="text-sm font-bold">Appointment Booking</p>
                        </div>
                        <p className="text-[11px] text-green-600/80 font-medium ml-6">
                          Everything is set. Confirm below to secure your slot.
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Place Order Button - The Hero CTA */}
                  <div className="pt-2">
                    <button
                      onClick={handlePlaceOrder}
                      className="group relative w-full overflow-hidden rounded-2xl bg-slate-900 p-[1px] transition-all active:scale-[0.98]"
                    >
                      <div className="relative flex items-center justify-center gap-2 bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 px-6 py-4 rounded-[15px] transition-all group-hover:opacity-90">
                        <span className="text-sm font-black uppercase tracking-[0.15em] text-white drop-shadow-md">
                          {orderOption === "booking" ? "Confirm Booking" : "Place Order Now"}
                        </span>
                        <svg
                          className="w-4 h-4 text-white transform transition-transform group-hover:translate-x-1"
                          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                      </div>
                    </button>

                    {/* Visual Reassurance */}
                    <p className="mt-3 text-center text-[10px] font-semibold text-slate-400 flex items-center justify-center gap-1.5 uppercase tracking-tighter">
                      <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" /></svg>
                      Secure encrypted checkout
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Dish Popup */}
      {selectedDish && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          {/* Backdrop with Blur */}
          <div
            className="absolute inset-0 bg-black/60 transition-opacity"
            onClick={() => setSelectedDish(null)}
          />

          {/* Main Card */}
          <div className="relative bg-white rounded-[2rem] max-w-md w-full shadow-2xl animate-fadeIn overflow-hidden flex flex-col max-h-[70vh]">

            {/* 1. Hero Image Section */}
            <div className="relative h-64 w-full shrink-0">
              {selectedDish.image ? (
                <img
                  src={selectedDish.image}
                  alt={selectedDish.name}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex flex-col items-center justify-center bg-gray-50 text-gray-400">
                  <span className="text-4xl mb-2">🖼️</span>
                  <span className="text-sm font-medium">No Image Available</span>
                </div>
              )}

              {/* Gradient Overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />

              {/* Floating Close Button (Glassmorphism) */}
              <button
                onClick={() => setSelectedDish(null)}
                className="absolute top-4 right-4 p-2 rounded-full bg-white/20 border border-white/30 text-white hover:bg-white hover:text-gray-900 transition-all duration-200 shadow-lg active:scale-95 group"
                aria-label="Close"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
              </button>
            </div>

            {/* 2. Content Section - Overlaps the image slightly */}
            <div className="relative -mt-8 bg-white rounded-t-[2rem] flex flex-col flex-1 overflow-hidden">

              {/* Header Content */}
              <div className="px-8 pt-8 pb-4 shrink-0">
                <div className="flex justify-between items-start gap-4">
                  <div>
                    {/* Decorative Category/Tag (Optional Placeholder) */}
                    <span className="text-xs font-bold tracking-wider text-amber-600 uppercase mb-1 block">
                      Detailed View
                    </span>
                    <h3 className="text-2xl font-bold text-gray-900 leading-tight tracking-tight">
                      {selectedDish.name}
                    </h3>
                  </div>

                  {/* Price - Large and Clear */}
                  <div className="flex flex-col items-end">
                    <span className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-amber-500 to-orange-600">
                      ₹{selectedDish.price}
                    </span>
                  </div>
                </div>

                {/* Divider */}
                <div className="w-full h-px bg-gray-100 my-4" />
              </div>

              {/* Scrollable Description Area */}
              <div className="px-8 pb-8 max-h-[30vh] overflow-y-auto custom-scrollbar">
                <div className="prose prose-sm prose-gray text-sm max-w-none text-gray-600 leading-relaxed">
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        selectedDish.description ||
                        "<p>No description available for this delicious item.</p>",
                    }}
                  />
                </div>
              </div>


              {/* Optional: Add to Cart / Action Bar (Sticky Bottom) */}
              {/* You can remove this div if you only need display, but it adds to the premium feel */}
              <div className="p-4 border-t border-gray-50 bg-gray-50/50">
                <button
                  onClick={() => setSelectedDish(null)} // Or add to cart logic
                  className="w-full py-3.5 rounded-xl bg-gray-900 text-white font-semibold text-sm hover:bg-gray-800 active:scale-[0.98] transition-all shadow-lg shadow-gray-200"
                >
                  Okay, Got it
                </button>
              </div>

            </div>
          </div>
        </div>
      )}




    </div>




  );



}

